import React from 'react';

const LoadingSpinner = ({ size = 'medium', text = null, className = '', color = 'cyan' }) => {
  const sizeClasses = {
    small: 'w-4 h-4 border',
    medium: 'w-8 h-8 border-2',
    large: 'w-12 h-12 border-3',
  };

  const colorClasses = {
    cyan: 'border-transparent border-t-cyan-400 border-r-cyan-400',
    white: 'border-transparent border-t-white border-r-white',
    teal: 'border-transparent border-t-teal-400 border-r-teal-400',
    emerald: 'border-transparent border-t-emerald-400 border-r-emerald-400',
    yellow: 'border-transparent border-t-amber-400 border-r-amber-400',
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div
        className={`animate-spin rounded-full ${colorClasses[color]} ${sizeClasses[size]}`}
      />
      {text && (
        <p className="mt-3 text-gray-600 text-sm font-medium">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;